import { Box, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";

import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { ApiContext } from "../../ApiContext";
import { AlertBar } from "../../Common/AlertBar";
import { UserContext } from "../../UserContext";
import { CustomizeButton } from "./Buttons/CustomizeButton";
import { FormCancel } from "./Buttons/FormCancel";
import { FormEdit } from "./Buttons/FormEdit";
import { FormSave } from "./Buttons/FormSave";

export const ContactDetail = ({ data, refreshData }) => {
	const debug = false;

	const [editMode, setEditMode] = useState(false);
	const [newEmail, setNewEmail] = useState("");
	const [newPhone, setNewPhone] = useState("");
	const [saving, setSaving] = useState(false);

	const { t } = useTranslation();
	const { ApiCall } = useContext(ApiContext);

	const { selectedLocation } = useContext(UserContext);

	const cancelAction = () => {
		setNewEmail(data.contact_email);
		setNewPhone(data.contact_phone);
		setEditMode(!editMode);
	};

	const handleSave = () => {
		setSaving(true);
		ApiCall("PUT", `client/location/${data.id}`, {
			contact_email: newEmail,
			contact_phone: newPhone
		})
			.then(() => {
				setEditMode(!editMode);
				refreshData(data.id);
				setSaving(false);
			})
			.catch((error) => {
				if (debug) console.log(error);
				setSaving(false);
			});
	};

	const checkStates = () => {
		if (newEmail === "" || newPhone === "") return true;
		else return false;
	};

	useEffect(() => {
		setEditMode(false);
		setNewEmail(data.contact_email);
		setNewPhone(data.contact_phone);
	}, [selectedLocation.id]);

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			sx={{
				padding: "15px",
				border: editMode ? "1px dashed " + ColorScheme.secondary: "0px",
				borderRadius: "4px"
			}}
		>
			<div
				style={{
					flexDirection: "row",
					display: "flex",
					flex: 1,
					justifyContent: "flex-start"
				}}
			>
				<div style={{ minWidth: isMobile ? "100px" : "150px" }}>
					<Typography variant="form_text_label">
						{t("location.form_contact_label")}:
					</Typography>
				</div>
				<Stack
					spacing={1}
					sx={{
						width: "100%" /* paddingTop: "3px" */
					}}
				>
					{editMode && (
					<AlertBar 
						textContent={t("location.contact_detail_description")} 
						type={"warning"}
						standardVariant={true}
						showAlert={true}
					/>
					)}
					{editMode ? (
						<FormEdit
							title={t("location.form_email_label")}
							value={newEmail}
							changeData={(value) => setNewEmail(value)}
							type={"text"}
							isRequired={true}
						/>
					) : (
						<Typography variant="form_text">{newEmail}</Typography>
					)}
					{editMode ? (
						<FormEdit
							title={t("location.form_phone_label")}
							value={newPhone}
							changeData={(value) => setNewPhone(value)}
							type={"tel"}
							onlyNumeric
							isRequired={true}
						/>
					) : (
						<Typography variant="form_text">{newPhone}</Typography>
					)}
					{editMode && (
						<Box
							sx={{
								width: "100%",
								display: "flex",
								justifyContent: "flex-end"
							}}
						>
							<FormCancel disabled={saving} cancelAction={cancelAction} />
							<FormSave
								check={checkStates()}
								handleSave={handleSave}
								activity={saving}
							/>
						</Box>
					)}
				</Stack>
			</div>
			{!editMode && (
				<CustomizeButton
					changeEditMode={() => setEditMode(!editMode)}
				/>
			)}
		</Stack>
	);
};
